import axios from "axios";

import config from "@/config";
import cookies from "@/util/cookies";

import { saveToCache, processError } from "./offline";

class AxiosPlugin {
  constructor() {
    this.instance = axios.create({
      baseURL: config.apiUrl,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
    });

    this.instance.interceptors.request.use(
      (axiosConfig) => {
        let api_token = cookies.get("api_token");
        if (api_token) {
          axiosConfig.headers.Authorization = "Bearer " + api_token;
        }
        return axiosConfig;
      },
      (error) => Promise.reject(error)
    );

    this.instance.interceptors.response.use((response) => {
      saveToCache(response);
      return response;
    }, processError);
  }

  install(Vue, options) {
    Vue.prototype.$axios = this.instance;
  }
}

const axiosPlugin = new AxiosPlugin();

export { axiosPlugin };

export default axiosPlugin.instance;
